module.exports = __webpack_public_path__ + "img/footer-m.a359e700.png";